import {useMemo} from 'react'
import {useHistory, useLocation} from 'react-router-dom'
import queryString from 'query-string'
import {debounce, isArray} from 'lodash'

export const useSearchQuery = () => {
  const history = useHistory()
  const {search, pathname} = useLocation()
  const query = queryString.parse(search)
  const q = query['q']
  const setSearchQuery = useMemo(
    () => debounce((q: string) => history.push({pathname, search: queryString.stringify({q})}), 1000),
    [history, pathname]
  )
  return {searchQuery: isArray(q) ? (q[0] ?? undefined) : (q ?? undefined), setSearchQuery}
}
